import { CLICK_PORTAL_RESULT_ROWS_DISPLAY } from 'consts';

/**
 * Portal Results listing UI. Explicit WP Display wins; empty/legacy values
 * follow site Multi Row so existing carousels stay result rows and
 * single-row landings stay a vertical list.
 */
export function resolveClickPortalResultRowsListingDisplay(
  listingDisplay: string | undefined,
  isMultiRowSite: boolean
): CLICK_PORTAL_RESULT_ROWS_DISPLAY {
  if (listingDisplay === CLICK_PORTAL_RESULT_ROWS_DISPLAY.VERTICAL_LIST) {
    return CLICK_PORTAL_RESULT_ROWS_DISPLAY.VERTICAL_LIST;
  }

  if (listingDisplay === CLICK_PORTAL_RESULT_ROWS_DISPLAY.RESULT_ROWS) {
    return CLICK_PORTAL_RESULT_ROWS_DISPLAY.RESULT_ROWS;
  }

  return isMultiRowSite
    ? CLICK_PORTAL_RESULT_ROWS_DISPLAY.RESULT_ROWS
    : CLICK_PORTAL_RESULT_ROWS_DISPLAY.VERTICAL_LIST;
}
